import Uti from "./uti.jpeg";
import majicBricks from "./magic_bricks.jpeg";
import daburVatika from "./dabur_vatika.jpeg";
import adda52 from "./adda52.png";
import karmacalling from "./karmacalling.png";
import relaxo from "./relaxo.png";
import brezza from "./brezza.png";
import divide from "./divide.png";
import vadilal from "./vadilal.png";
import setlife from "./setlife.png";
import hanuman from "./hanuman.png";
import bittersweet from "./bittersweet.png";
import karmmacallingBloppers from "./karmmacallingbloppers.png";
import hundredBts from "./hundredbts.png";
import vadilalBts from "./vadilalbts.png";
import vadilalMisunderstood from "./vadilalmisunderstood.png";
import vadialalAstronaut from "./vadilalastronaut.png";
import vadilalEmbarassed from "./vadilalembarassed.png";
import vadialalFollowers from "./vadilalfollowers.png";
import vadilalHotGuy from "./vadilalhotguy.png";
import vadilalFriendZoned from "./vadilalfriendzoned.png";
import snickersBts from "./snickers.png";
import theworldofKarmmacalling from "./worldofkarmmacalling.png";
import varunSood from "./varunsood.png";
import indraniKothari from "./indranikothari.png";

export const btsplaylistThumnail = {
  adda52,
  Uti,
  daburVatika,
  majicBricks,
  karmacalling,
  relaxo,
  brezza,
  divide,
  vadilal,
  setlife,
  hanuman,
  bittersweet,
  karmmacallingBloppers,
  hundredBts,
  vadilalBts,
  vadilalMisunderstood,
  vadialalAstronaut,
  vadilalEmbarassed,
  vadialalFollowers,
  vadilalHotGuy,
  vadilalFriendZoned,
  snickersBts,
  theworldofKarmmacalling,
  varunSood,
  indraniKothari,
};
